import React from 'react';
import { createPortal } from 'react-dom';
import './ResponsiveModal.css';

const ResponsiveModal = ({
  isOpen,
  onClose,
  title,
  subtitle,
  children,
  footer,
  size = 'md'
}) => {
  if (!isOpen) return null;

  return createPortal(
    <div
      className="df-modal-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) {
          onClose();
        }
      }}
      role="dialog"
      aria-modal="true"
      aria-labelledby="df-modal-title"
    >
      <div className={`df-modal-dialog df-modal-${size}`}>
        <div className="df-modal-header">
          <div>
            {title && <h3 id="df-modal-title" className="df-modal-title">{title}</h3>}
            {subtitle && <p className="df-modal-subtitle">{subtitle}</p>}
          </div>
          <button
            type="button"
            className="df-modal-close"
            onClick={onClose}
            aria-label="Cerrar ventana"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>

        <div className="df-modal-body">
          {children}
        </div>

        {footer && (
          <div className="df-modal-footer">
            {footer}
          </div>
        )}
      </div>
    </div>,
    document.body
  );
};

export default ResponsiveModal;
